// TODO NEXT
// make bulk edit root only for starters?
import { html, css } from 'lit-element';
import { connect } from '../store/connect';
import { actions, selectors } from './';
import { selectors as accountSelectors } from '../account';
import '../form/form-element-bulk-user';
import '../form/confirm-bulk-save';
import { UserDetailBase } from './user-detail-base';
import { AUTHORIZATIONS } from '../authorizations/authorizations';

class UserDetailBulkEdit extends UserDetailBase {
    constructor() {
        super();
    }

    static get styles() {
        return [
            ...super.styles,
            css`
                :host {
                    min-width: 500px;
                }
            `,
        ];
    }

    static get properties() {
        return {
            bulkApplyPaths: {
                type: Array,
            },
            selectedUsersCount: {
                type: Number,
            },
        };
    }

    render() {
        return html`<div class="fixed-header">${this.renderHeader()}</div>
            ${this.renderMain()}`;
    }

    renderMain() {
        const { authorizations } = this;
        return this.renderUserDetails();
    }

    renderUserDetails() {
        return html`${this.renderControls()} ${this.renderValidationErrors()} ${this.renderForm()}`;
    }

    renderHeader() {
        const { selectedUsersCount } = this;
        return html`<h1>Bulk Edit Users: ${selectedUsersCount} selected</h1>`;
    }

    renderControls() {
        const {
            bulkApplyPaths,
            isSaving,
            isLoading,
            activeAuthSite,
            authorizations,
            selectedUsersCount,
        } = this;
        const disableForAction = isSaving || isLoading;
        const noFieldsSelected = !bulkApplyPaths?.length;
        const noUsersSelected = selectedUsersCount === 0;
        const disableSave = disableForAction || noFieldsSelected;
        const controls = [];
        controls.push(
            html`<confirm-bulk-save-btn
                @bulk-save-confirmed=${this.handleSave}
                .disabled=${disableSave}
                .count=${selectedUsersCount}
                >Update All</confirm-bulk-save-btn
            >`
        );
        const routeData = { authSite: activeAuthSite };
        controls.push(
            html`<tmn-button .disabled=${disableForAction} .data=${routeData} @click=${this.cancel}
                >Cancel</tmn-button
            >`
        );
        controls.push(
            html`<confirm-bulk-save-btn
                @bulk-save-confirmed=${this.handleActivate}
                .disabled=${noUsersSelected}
                .count=${selectedUsersCount}
                .actionLabel=${'Activate'}
                >Activate Selected</confirm-bulk-save-btn
            >`
        );
        controls.push(
            html`<confirm-bulk-save-btn
                @bulk-save-confirmed=${this.handleDeactivate}
                .disabled=${noUsersSelected}
                .count=${selectedUsersCount}
                .actionLabel=${'Deactivate'}
                >Deactivate Selected</confirm-bulk-save-btn
            >`
        );
        return html`<div class="controls-container">${controls}</div> `;
    }

    renderFormElement(itemTemplate, path) {
        return html`<form-element-bulk-user
            .itemTemplate=${itemTemplate}
            .path=${path}></form-element-bulk-user>`;
    }
    handleDeactivate() {
        this.actions.bulkDeactivateUser();
    }
    handleActivate() {
        this.actions.bulkActivateUser();
    }

    handleSave() {
        this.actions.bulkEditUserSave();
    }

    cancel() {
        this.actions.exitBulkEditMode();
    }
}
const mapStateToProps = (state, ownProps) => {
    return (state) => {
        const selectedUsersCount = selectors.selectedUserIdsSelector(state)?.length || 0;
        return {
            activeAuthSite: selectors.activeAuthSiteNameSelector(state),
            userTemplate: selectors.userConfigTemplateSelector(state),
            validationErrors: selectors.userValidationErrorsSelector(state),
            detailMode: selectors.userDetailModeSelector(state),
            isSaving: selectors.userIsSavingSelector(state),
            isLoading: selectors.userIsLoadingSelector(state),
            authorizations: accountSelectors.accountAuthorizationsSelector(state),
            bulkApplyPaths: selectors.bulkUserApplyPathsSelector(state),
            selectedUsersCount,
        };
    };
};

const combinedActions = {
    ...actions,
};

customElements.define(
    'user-detail-bulk-edit',
    connect(mapStateToProps, combinedActions)(UserDetailBulkEdit)
);
